<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter" id="ach1" title="Slow Cooker Aquafaba">
<p class="h2"><span class="right_1" epub:type="pagebreak" id="page_10" title="10"><a href="#/text/Contents#ch1">Slow Cooker Aquafaba</a></span></p>
<p class="noindentb"><i>Using a slow cooker is the easiest way to make your own AF. Presoak the beans for at least an hour if you want to prevent them from splitting while they cook (optional, but recommended if you intend to use the beans whole in other recipes). While the overnight refrigeration cool is not necessary, I find it helps out greatly. You can halve this recipe, but I find a halved recipe works better on the stovetop than in the slow cooker.</i></p>
<p class="recl">12 cups water</p>
<p class="recl">pinch kosher salt</p>
<p class="reclb">4 cups (2 pounds) dried chickpeas, rinsed well</p>
<p class="noindentb"><b>1.</b> If you have the time, soak the chickpeas in warm (not hot) water for at least an hour.</p>
<p class="noindentb"><b>2.</b> Place the water and salt together in a pot with a lid. Cover and bring to a boil.</p>
<p class="noindentb"><b>3.</b> Place the chickpeas into your slow cooker. Carefully pour the boiling water over the chickpeas. Cook on low for 8 to 10 hours.</p>
<p class="noindentb"><b>4.</b> Remove the slow cooker insert and allow the beans and liquid to cool together in the slow cooker insert until it reaches room temperature. Drain the aquafaba from the chickpeas and store both in the fridge. (You can use the chickpeas immediately if so desired.) Allow the aquafaba to rest in the refrigerator overnight.</p>
<p class="noindentb"><i>Note:</i> Remember the aquafaba is always thinner when it is hot! Use only cool or room-temperature AF. Excess aquafaba can be frozen in ice cube trays for future use.</p>
<p class="noindent1"><span class="small">YIELD:</span> 6 cups aquafaba, plus 14 cups cooked chickpeas<span class="space"><span class="hide">     </span><span class="small">PREP TIME:</span> 10 minutes, plus at least one hour to soak (optional)<span class="space"><span class="hide">     </span><span class="small">COOK TIME:</span> 8 to 10 hours, plus overnight cooling</span></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter001.vue?18d39327